import { DOWNSELL_TOAST_VARIANT_STORAGE_KEY } from 'src/constants/storageKeys.const';
import { getLocalStorageEntry, setLocalStorageEntry } from 'src/utils/webStorageUtils';
import { randomInteger } from 'src/utils/numbers';

export type DownsellVariant = 'control' | 'treatment';

const isDownsellVariant = (value: string | null): value is DownsellVariant =>
  value === 'control' || value === 'treatment';

const storageKey = (userId: number | null | undefined) =>
  userId ? `${DOWNSELL_TOAST_VARIANT_STORAGE_KEY}-${userId}` : DOWNSELL_TOAST_VARIANT_STORAGE_KEY;

/**
 * Local-only 50/50 control-vs-treatment split, standing in for a real MEME experiment
 * (FeaturesApi) until a slug is registered for this surface. The arm is persisted so a given
 * user consistently lands in the same arm instead of re-randomizing on every dismiss.
 */
export const getDownsellVariant = (userId: number | null | undefined): DownsellVariant => {
  const key = storageKey(userId);
  const stored = getLocalStorageEntry(key);
  if (isDownsellVariant(stored)) return stored;

  const variant: DownsellVariant =
    randomInteger({ min: 0, max: 2 }) === 0 ? 'control' : 'treatment';
  setLocalStorageEntry(key, variant);
  return variant;
};
